<template>
  <div class="page-wrapper">
    <div class="logo-container">
      <a href="/">
        <svg
          width="203"
          height="26"
          viewBox="0 0 203 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.9603 15.892C11.9603 15.364 11.9243 14.824 11.8523 14.272C11.8043 13.72 11.6603 13.216 11.4203 12.76C11.1803 12.304 10.8083 11.932 10.3043 11.644C9.82427 11.332 9.14027 11.176 8.25227 11.176C7.36427 11.176 6.66827 11.332 6.16427 11.644C5.68427 11.932 5.32427 12.304 5.08427 12.76C4.84427 13.216 4.68827 13.72 4.61627 14.272C4.56827 14.824 4.54427 15.364 4.54427 15.892V25H0.152266V15.892C0.152266 14.644 0.260266 13.552 0.476266 12.616C0.716266 11.68 1.02827 10.876 1.41227 10.204C1.79627 9.508 2.22827 8.932 2.70827 8.476C3.18827 8.02 3.68027 7.648 4.18427 7.36C5.36027 6.688 6.71627 6.328 8.25227 6.28C9.76427 6.328 11.1083 6.688 12.2843 7.36C12.7883 7.648 13.2803 8.02 13.7603 8.476C14.2643 8.932 14.6963 9.508 15.0563 10.204C15.4403 10.876 15.7523 11.68 15.9923 12.616C16.2323 13.552 16.3523 14.644 16.3523 15.892V25H11.9603V15.892ZM23.7683 15.892C23.7683 15.364 23.7323 14.824 23.6603 14.272C23.6123 13.72 23.4683 13.216 23.2283 12.76C22.9883 12.304 22.6163 11.932 22.1123 11.644C21.6323 11.332 20.9483 11.176 20.0603 11.176C19.1723 11.176 18.4763 11.332 17.9723 11.644C17.4923 11.932 17.1323 12.304 16.8923 12.76C16.6523 13.216 16.4963 13.72 16.4243 14.272C16.3763 14.824 16.3523 15.364 16.3523 15.892V25H11.9603V15.892C11.9603 14.644 12.0683 13.552 12.2843 12.616C12.5243 11.68 12.8363 10.876 13.2203 10.204C13.6043 9.508 14.0363 8.932 14.5163 8.476C14.9963 8.02 15.4883 7.648 15.9923 7.36C17.1683 6.688 18.5243 6.328 20.0603 6.28C21.5723 6.328 22.9163 6.688 24.0923 7.36C24.5963 7.648 25.0883 8.02 25.5683 8.476C26.0723 8.932 26.5043 9.508 26.8643 10.204C27.2483 10.876 27.5603 11.68 27.8003 12.616C28.0403 13.552 28.1603 14.644 28.1603 15.892V25H23.7683V15.892ZM47.2723 13.552C47.3203 13.912 47.3563 14.284 47.3803 14.668C47.4283 15.052 47.4523 15.46 47.4523 15.892V16.54H34.8523C34.9003 16.948 34.9603 17.368 35.0323 17.8C35.1043 18.208 35.2243 18.616 35.3923 19.024C35.6563 19.648 36.0643 20.2 36.6163 20.68C37.1683 21.16 37.9363 21.4 38.9203 21.4C39.9043 21.4 40.6723 21.16 41.2243 20.68C41.7763 20.2 42.1843 19.648 42.4483 19.024H47.1283C46.9363 19.864 46.6603 20.596 46.3003 21.22C45.9643 21.844 45.5803 22.384 45.1483 22.84C44.7403 23.296 44.2963 23.68 43.8163 23.992C43.3363 24.28 42.8683 24.52 42.4123 24.712C41.3083 25.144 40.1443 25.36 38.9203 25.36C37.3123 25.336 35.8843 25 34.6363 24.352C34.1083 24.064 33.5803 23.704 33.0523 23.272C32.5483 22.816 32.0923 22.252 31.6843 21.58C31.3003 20.908 30.9883 20.104 30.7483 19.168C30.5083 18.232 30.3883 17.14 30.3883 15.892C30.3883 14.644 30.5083 13.552 30.7483 12.616C30.9883 11.68 31.3003 10.876 31.6843 10.204C32.0923 9.508 32.5483 8.932 33.0523 8.476C33.5803 8.02 34.1083 7.648 34.6363 7.36C35.8843 6.688 37.3123 6.328 38.9203 6.28C40.2403 6.328 41.4763 6.604 42.6283 7.108C43.1083 7.324 43.5883 7.612 44.0683 7.972C44.5723 8.308 45.0283 8.74 45.4363 9.268C45.8683 9.772 46.2403 10.384 46.5523 11.104C46.8883 11.8 47.1283 12.616 47.2723 13.552ZM42.7363 13.552C42.6163 13.168 42.4603 12.784 42.2683 12.4C42.1003 12.016 41.8603 11.668 41.5483 11.356C41.2363 11.044 40.8643 10.804 40.4323 10.636C40.0003 10.444 39.4963 10.348 38.9203 10.348C38.3443 10.348 37.8403 10.444 37.4083 10.636C36.9763 10.804 36.6043 11.044 36.2923 11.356C35.9803 11.668 35.7283 12.016 35.5363 12.4C35.3443 12.784 35.2003 13.168 35.1043 13.552H42.7363ZM57.7523 6.28C57.8243 6.28 58.0763 6.292 58.5083 6.316C58.9643 6.34 59.4923 6.448 60.0923 6.64C60.6923 6.808 61.3283 7.084 62.0003 7.468C62.6723 7.852 63.2963 8.404 63.8723 9.124C64.4483 9.844 64.9163 10.756 65.2763 11.86C65.6603 12.94 65.8523 14.284 65.8523 15.892V25H61.4603V15.892C61.4603 15.364 61.4123 14.824 61.3163 14.272C61.2203 13.72 61.0403 13.216 60.7763 12.76C60.5123 12.304 60.1403 11.932 59.6603 11.644C59.1803 11.332 58.5443 11.176 57.7523 11.176C56.9603 11.176 56.3243 11.332 55.8443 11.644C55.3643 11.932 54.9923 12.304 54.7283 12.76C54.4643 13.216 54.2843 13.72 54.1883 14.272C54.0923 14.824 54.0443 15.364 54.0443 15.892V25H49.6523V15.892C49.6523 14.284 49.8323 12.94 50.1923 11.86C50.5763 10.756 51.0563 9.844 51.6323 9.124C52.2083 8.404 52.8323 7.852 53.5043 7.468C54.1763 7.084 54.8123 6.808 55.4123 6.64C56.0123 6.448 56.5283 6.34 56.9603 6.316C57.3923 6.292 57.6563 6.28 57.7523 6.28ZM72.5398 11.032V19.06C72.6118 19.348 72.7438 19.612 72.9358 19.852C73.1038 20.044 73.3318 20.224 73.6198 20.392C73.9318 20.56 74.3278 20.644 74.8078 20.644H77.5438V25H73.1518C72.2158 24.904 71.3758 24.64 70.6318 24.208C70.0078 23.848 69.4318 23.32 68.9038 22.624C68.3998 21.904 68.1478 20.92 68.1478 19.672V1.852H72.5398V6.748H76.6798V11.032H72.5398ZM96.5271 25H92.2431V22.48L93.0351 21.436C92.6271 22.444 92.1111 23.212 91.4871 23.74C90.8631 24.268 90.2511 24.652 89.6511 24.892C88.9551 25.156 88.2351 25.312 87.4911 25.36C86.0031 25.336 84.6831 25 83.5311 24.352C83.0271 24.064 82.5351 23.704 82.0551 23.272C81.5991 22.816 81.1791 22.252 80.7951 21.58C80.4351 20.908 80.1351 20.104 79.8951 19.168C79.6791 18.232 79.5711 17.14 79.5711 15.892C79.5711 14.644 79.6911 13.552 79.9311 12.616C80.1711 11.68 80.4831 10.876 80.8671 10.204C81.2751 9.508 81.7311 8.932 82.2351 8.476C82.7631 8.02 83.2911 7.648 83.8191 7.36C85.0671 6.688 86.4951 6.328 88.1031 6.28C89.6151 6.28 90.8991 6.508 91.9551 6.964C93.0111 7.396 93.8751 8.032 94.5471 8.872C95.2431 9.688 95.7471 10.696 96.0591 11.896C96.3711 13.072 96.5271 14.416 96.5271 15.928V25ZM88.1031 10.528C87.2151 10.528 86.4951 10.708 85.9431 11.068C85.4151 11.428 85.0071 11.884 84.7191 12.436C84.4311 12.964 84.2391 13.54 84.1431 14.164C84.0471 14.788 83.9991 15.364 83.9991 15.892C83.9991 16.42 84.0471 16.996 84.1431 17.62C84.2391 18.244 84.4311 18.832 84.7191 19.384C85.0071 19.912 85.4151 20.356 85.9431 20.716C86.4951 21.076 87.2151 21.256 88.1031 21.256C88.9911 21.256 89.6991 21.076 90.2271 20.716C90.7791 20.356 91.1991 19.912 91.4871 19.384C91.7991 18.832 92.0031 18.244 92.0991 17.62C92.1951 16.996 92.2431 16.42 92.2431 15.892C92.2431 15.244 92.1951 14.608 92.0991 13.984C92.0271 13.336 91.8471 12.76 91.5591 12.256C91.2951 11.728 90.8871 11.308 90.3351 10.996C89.7831 10.684 89.0391 10.528 88.1031 10.528ZM103.302 0.7V25H98.9104V0.7H103.302ZM121.318 8.044V12.112H117.538V25H113.254V6.028C113.254 4.78 113.506 3.808 114.01 3.112C114.538 2.392 115.114 1.852 115.738 1.492C116.482 1.06 117.322 0.796 118.258 0.7H123.298V4.768H119.914C119.338 4.768 118.894 4.864 118.582 5.056C118.27 5.248 118.03 5.464 117.862 5.704C117.67 5.968 117.562 6.28 117.538 6.64V8.044H121.318ZM133.409 25.36C133.337 25.36 133.073 25.348 132.617 25.324C132.185 25.3 131.669 25.192 131.069 25C130.469 24.832 129.833 24.556 129.161 24.172C128.489 23.788 127.865 23.236 127.289 22.516C126.713 21.796 126.233 20.896 125.849 19.816C125.489 18.712 125.309 17.356 125.309 15.748V6.748H129.701V15.748C129.701 16.276 129.749 16.816 129.845 17.368C129.941 17.92 130.121 18.424 130.385 18.88C130.649 19.336 131.021 19.72 131.501 20.032C131.981 20.32 132.617 20.464 133.409 20.464C134.201 20.464 134.837 20.32 135.317 20.032C135.797 19.72 136.169 19.336 136.433 18.88C136.697 18.424 136.877 17.92 136.973 17.368C137.069 16.816 137.117 16.276 137.117 15.748V6.748H141.509V15.748C141.509 17.356 141.317 18.712 140.933 19.816C140.573 20.896 140.105 21.796 139.529 22.516C138.953 23.236 138.329 23.788 137.657 24.172C136.985 24.556 136.349 24.832 135.749 25C135.149 25.192 134.621 25.3 134.165 25.324C133.733 25.348 133.481 25.36 133.409 25.36ZM148.196 11.032V19.06C148.268 19.348 148.4 19.612 148.592 19.852C148.76 20.044 148.988 20.224 149.276 20.392C149.588 20.56 149.984 20.644 150.464 20.644H153.2V25H148.808C147.872 24.904 147.032 24.64 146.288 24.208C145.664 23.848 145.088 23.32 144.56 22.624C144.056 21.904 143.804 20.92 143.804 19.672V1.852H148.196V6.748H152.336V11.032H148.196ZM163.291 25.36C163.219 25.36 162.955 25.348 162.499 25.324C162.067 25.3 161.551 25.192 160.951 25C160.351 24.832 159.715 24.556 159.043 24.172C158.371 23.788 157.747 23.236 157.171 22.516C156.595 21.796 156.115 20.896 155.731 19.816C155.371 18.712 155.191 17.356 155.191 15.748V6.748H159.583V15.748C159.583 16.276 159.631 16.816 159.727 17.368C159.823 17.92 160.003 18.424 160.267 18.88C160.531 19.336 160.903 19.72 161.383 20.032C161.863 20.32 162.499 20.464 163.291 20.464C164.083 20.464 164.719 20.32 165.199 20.032C165.679 19.72 166.051 19.336 166.315 18.88C166.579 18.424 166.759 17.92 166.855 17.368C166.951 16.816 166.999 16.276 166.999 15.748V6.748H171.391V15.748C171.391 17.356 171.199 18.712 170.815 19.816C170.455 20.896 169.987 21.796 169.411 22.516C168.835 23.236 168.211 23.788 167.539 24.172C166.867 24.556 166.231 24.832 165.631 25C165.031 25.192 164.503 25.3 164.047 25.324C163.615 25.348 163.363 25.36 163.291 25.36ZM173.615 12.076C173.615 10.828 173.879 9.856 174.407 9.16C174.935 8.44 175.511 7.9 176.135 7.54C176.879 7.108 177.719 6.844 178.655 6.748H183.695V11.104H180.311C179.831 11.104 179.435 11.188 179.123 11.356C178.835 11.524 178.607 11.704 178.439 11.896C178.247 12.136 178.115 12.4 178.043 12.688V25H173.615V12.076ZM202.628 13.552C202.676 13.912 202.712 14.284 202.736 14.668C202.784 15.052 202.808 15.46 202.808 15.892V16.54H190.208C190.256 16.948 190.316 17.368 190.388 17.8C190.46 18.208 190.58 18.616 190.748 19.024C191.012 19.648 191.42 20.2 191.972 20.68C192.524 21.16 193.292 21.4 194.276 21.4C195.26 21.4 196.028 21.16 196.58 20.68C197.132 20.2 197.54 19.648 197.804 19.024H202.484C202.292 19.864 202.016 20.596 201.656 21.22C201.32 21.844 200.936 22.384 200.504 22.84C200.096 23.296 199.652 23.68 199.172 23.992C198.692 24.28 198.224 24.52 197.768 24.712C196.664 25.144 195.5 25.36 194.276 25.36C192.668 25.336 191.24 25 189.992 24.352C189.464 24.064 188.936 23.704 188.408 23.272C187.904 22.816 187.448 22.252 187.04 21.58C186.656 20.908 186.344 20.104 186.104 19.168C185.864 18.232 185.744 17.14 185.744 15.892C185.744 14.644 185.864 13.552 186.104 12.616C186.344 11.68 186.656 10.876 187.04 10.204C187.448 9.508 187.904 8.932 188.408 8.476C188.936 8.02 189.464 7.648 189.992 7.36C191.24 6.688 192.668 6.328 194.276 6.28C195.596 6.328 196.832 6.604 197.984 7.108C198.464 7.324 198.944 7.612 199.424 7.972C199.928 8.308 200.384 8.74 200.792 9.268C201.224 9.772 201.596 10.384 201.908 11.104C202.244 11.8 202.484 12.616 202.628 13.552ZM198.092 13.552C197.972 13.168 197.816 12.784 197.624 12.4C197.456 12.016 197.216 11.668 196.904 11.356C196.592 11.044 196.22 10.804 195.788 10.636C195.356 10.444 194.852 10.348 194.276 10.348C193.7 10.348 193.196 10.444 192.764 10.636C192.332 10.804 191.96 11.044 191.648 11.356C191.336 11.668 191.084 12.016 190.892 12.4C190.7 12.784 190.556 13.168 190.46 13.552H198.092Z"
            fill="white"
          />
        </svg>
      </a>
    </div>
    <div class="login-back">
      <button @click="$router.back()" class="login-back__btn">
        <img src="@/static/settings/arrow.svg" alt="Arrow back" title="Back" />
      </button>
    </div>
    <div class="login">
      <div class="login__title account-title">Account removal request</div>
      <div class="login__form-wrapper account-form-wrapper">
        <form class="login__form" @submit.prevent="handleSubmit">
          <div class="login__inputs">
            <div class="login__input-wrapper input-wrapper">
              <input
                type="email"
                placeholder="Email"
                v-model="email"
                class="with-icon"
              />
              <p
                class="login__input-error error-message"
                v-if="status && errors.errors && errors.errors.email"
              >
                {{ errors.errors.email[0] }}
              </p>
            </div>

            <div
              class="login__input-wrapper input-wrapper input-wrapper--login"
            >
              <button type="submit">
                <span class="text">Submit removal request</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { notification } from 'ant-design-vue'

export default {
  name: 'DataRemoval',
  data() {
    return {
      email: '',
      device_name: 'web',
      password: '',
      errors: {},
      status: false,
    }
  },
  async mounted() {},
  methods: {
    handleSubmit() {
      axios
        .post(`user/request-remove`, {
          email: this.email,
          device_name: this.device_name,
        })
        .then(() => {
          this.email = ''
          notification.success({
            message:
              'We have sent you an email. Please click on the link in the email to confirm your account removal request.',
          })
        })
        .catch((errors) => {
          this.errors = errors
          console.log(errors)
          this.status = true
        })
    },
  },
}
</script>

<style lang="scss">
@import '../assets/common';

.g-btn-wrapper {
  display: block !important;
}

.logo-container {
  padding: 36px 36px 60px;
}

.page-wrapper {
  min-height: 100vh;
  overflow: hidden;
}

.account-title {
  font-family: var(--run);
  font-size: 32px;
  line-height: 1;
  text-transform: lowercase;
  color: #fff;
  margin-bottom: 48px;
}

.account-form-wrapper {
  width: 100%;
  max-width: 327px;
}

.account-text {
  font-size: 12px;
  color: #fff;
  text-align: center;
  margin-top: 32px;

  span {
    font-weight: 400;
  }

  a {
    font-weight: 700;
    display: block;
    /* margin-top: 8px; */
  }
}

.account-privacy-policy {
  font-weight: 400;
  font-size: 12px;
  margin-top: 32px;
  color: #fff;
  text-align: center;

  a {
    font-weight: 700;
    display: block;
  }
}

.error-message {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  color: #fff;
  padding-top: 5px;
}

.input-wrapper {
  position: relative;
  margin-bottom: 16px;

  &--login,
  &--sign-up {
    width: 100%;
    height: 52px;
    border-radius: 58px;
    margin-top: 36px;

    button {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      border-radius: 58px;
      background-color: var(--color-white);
      padding: 17px 36px;
      color: var(--color-main);
      transition: 0.4s ease;
      z-index: 1;
      border: 0;
      font-family: var(--manrope-medium) !important;
      font-size: 14px;
      line-height: 19px;

      .text {
        position: relative;
        color: var(--color-main);
        z-index: 1;
      }

      &:after {
        content: '';
        position: absolute;
        inset: 0;
        background: var(--theme-green-forest);
        opacity: 0;
        border-radius: 58px;
        z-index: -1;
      }

      &:hover,
      &:focus {
        &:after {
          opacity: 0.15;
        }
      }
    }
  }

  input {
    display: block;
    width: 100%;
    background: transparent;
    text-align: center;
    color: #fff;
    padding: 18px 50px;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(255, 255, 255, 0.1);
    border-radius: 58px;

    &:focus {
      outline: 0;
      border-color: rgba(255, 255, 255, 0.8);

      &::placeholder {
        opacity: 0.3;
      }
    }
    &::placeholder {
      font-weight: 500;
      font-size: 14px;
      color: #fff;
      text-align: center;
    }

    &:disabled {
      cursor: not-allowed;
    }
  }

  .icon {
    position: absolute;
    left: 25px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    width: 24px;
    height: 24px;

    svg {
      width: 100%;
      height: 100%;
    }
  }
}

.login-back {
  padding: 0 36px;
  &__btn {
    background-color: inherit;
    border: none;
    cursor: pointer;
  }
}

.login {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 76px;

  &__input-wrapper {
    margin-bottom: 16px;
  }

  &__password-forgotten {
    font-weight: 400;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-bottom: 16px;
  }

  &__text {
    font-weight: 700;
    font-size: 12px;
    text-align: center;
    text-transform: uppercase;
    color: #fff;
    margin-bottom: 24px;
  }

  &__wrapper-social {
    position: relative;

    .icon {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 25px;
      display: flex;
      align-items: center;
      width: 24px;
      height: 24px;

      svg {
        width: 100%;
        height: 100%;
      }
    }
  }

  &__link {
    position: relative;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    padding: 16px 55px;
    border: none;
    width: 100%;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 58px;
    margin-bottom: 16px;
    color: var(--color-white);

    &:hover,
    &:focus {
      background: rgba(255, 255, 255, 0.15);
      color: var(--color-white);
    }
  }
}
</style>
